import { create } from "zustand";

// Define the store for the certificate state
const useCertStore = create((set) => ({
  // The certificate data object
  certificate: null,
  // Action to set the certificate data
  setCertificate: (certData) => {
    return set({ certificate: certData });
  },
}));

export default useCertStore;
